// 1.添加自定义文件 preventReClick.js    节流===定时器实现
import Vue from 'vue'
const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 3000)
            }
        })
    }
});

export default { preventReClick }


// WEBPACK FOOTER //
// ./src/assets/preventReClick.js